import { RootState } from "../store";

export const getAllHolders = (state: RootState) => state.holder.allHolders;
export const getHolder = (state: RootState) => state.holder.holder;
export const getCreatedHolder = (state: RootState) =>
  state.holder.createdHolder;
export const getDeletedHolder = (state: RootState) =>
  state.holder.deletedHolder;
export const getUpdatedHolder = (state: RootState) =>
  state.holder.updatedHolder;
export const getHolderPasswordReset = (state: RootState) =>
  state.holder.passwordReset;
export const getHolderById = (state: RootState) => (id: string) => {
  return state.holder.allHolders.data?.results.find((f) => f.uid === id);
};
